export enum InteractionEventType {
  BusinessEvent = 'businessEvent',
  ContentSwitch = 'contentSwitch',
}
